'use strict';

require('./mixins/mixins.js');
require('./utils.js');
require('./models/postTag.js');
require('./collections/postTags.js');
require('./data/postTags.js');
require('./views/postTagsManager.js');
